import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Home from './pages/Home';
import ListaPresentes from './pages/ListaPresentes';
import ConfirmacaoPresencas from './pages/ConfirmacaoPresencas';
import Cerimonia from './pages/Cerimonia';
import Header from './components/Header';
import Footer from './components/Footer';
import './App.css';

function App() {
  return (
    <Router>
      <div className="app-container">
        <Header />
        <main className="main-content">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/listapresentes" element={<ListaPresentes />} />
            <Route path="/confirmacaopresencas" element={<ConfirmacaoPresencas />} />
            <Route path="/cerimonia" element={<Cerimonia />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;